module.exports = new __parcel__URL__("resources_tab_active.b94f17c6.png").toString();